import React from 'react';
import Divider from '../components/ui/Divider/Divider';

const DividerSlice = () => (
  <Divider />
);

export default DividerSlice;
